import { render } from "./breadcrumbs.vue?vue&type=template&id=24861f25&scoped=true"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"

import "./breadcrumbs.vue?vue&type=style&index=0&id=24861f25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24861f25"]])

export default __exports__